import { instance3 } from "App/constants";

export const getTabData = async ({ id, url }) => {
  try {
    const res = await instance3.get(`${url}/${id}`);
    if (res.data.status === 200) {
      return {
        state: true,
        message: "success",
        data: res.data.data,
      };
    } else {
      return {
        state: false,
        message: res.data.message,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error.response.data.message,
      data: [],
    };
  }
};
